module.exports = __webpack_public_path__ + "images/components/estimate_banners/form_with_image/20-copy_047f13a1693b7331a97e4721a6e086ea.svg";